<template>
  <div class="card-header bg-info text-light">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'GroupHeader'
}
</script>
